// Projects.jsx
import React from "react";

function Projects() {
    const servicosEmpresas = [
        "Diagnóstico organizacional e práticas de RH",
        "Manual de cultura organizacional",
        "Recrutamento e seleção (estratégico e operacional)",
        "Palestras: Saúde Mental, Liderança Feminina, Cultura",
        "Mentoria para líderes iniciantes",
        "Programas de Estágio e Trainee",
        "Estruturação de cargos e salários"
    ];

    const servicosPessoas = [
        "Consultoria de Recolocação",
        "Reformulação de Currículo e LinkedIn",
        "Mentoria de Carreira"
    ];

    return (
        <section id="projects" className="py-20 bg-pink-50">
            <div className="container mx-auto">
                <h2 className="text-3xl font-bold text-center mb-8">Serviços</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div className="bg-white p-6 shadow rounded-lg">
                        <h3 className="text-xl font-semibold mb-4">Para Empresas</h3>
                        <ul className="list-disc list-inside text-gray-700 space-y-2">
                            {servicosEmpresas.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                    <div className="bg-white p-6 shadow rounded-lg">
                        <h3 className="text-xl font-semibold mb-4">Para Pessoas</h3>
                        <ul className="list-disc list-inside text-gray-700 space-y-2">
                            {servicosPessoas.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Projects;
